'use client';

import { PropsWithChildren, useCallback } from 'react';
import { useOrderFormStore } from '@/lib/store/order-form-store';
import { EMarketAction } from '@/lib/types/market-action';
import { Drawer, DrawerContent, DrawerTitle } from '@/lib/ui-kit/drawer';

export const OrderFormMobileContainer = ({ children }: PropsWithChildren) => {
  // CRITICAL FIX: Use specific selectors
  const isMobileFormOpened = useOrderFormStore.use.isMobileFormOpened();
  const setIsMobileFormOpened = useOrderFormStore.use.setIsMobileFormOpened();
  const setAction = useOrderFormStore.use.setAction();

  const handleOpenChange = useCallback(
    (open: boolean) => {
      setIsMobileFormOpened(open);
      if (!open) {
        setAction(EMarketAction.BUY);
      }
    },
    [setAction, setIsMobileFormOpened],
  );

  return (
    <Drawer repositionInputs={false} open={isMobileFormOpened} onOpenChange={handleOpenChange}>
      <DrawerContent className="inset-x-0 bottom-0 max-h-[90dvh] border-v2-border px-4 pb-4 pt-2 transition-[height] [&>:last-child]:mt-5">
        <DrawerTitle className="sr-only">Order Form</DrawerTitle>
        {children}
      </DrawerContent>
    </Drawer>
  );
};
